<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Message',
})
</script>
<template>
  <div v-if="isShow">
    <!-- 遮罩层 -->
    <div v-if="mask" class="toast-mask" :style="{ zIndex }" />

    <!-- 消息内容 -->
    <div class="mod-message-wrapper" :style="{ zIndex }">
      <div class="mod-message animation-show">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script setup name="Message" lang="ts">
import { ref, watch, onUnmounted } from "vue";
import { useRouter } from "vue-router";

// 定义消息配置接口
interface MessageConfig {
  title?: string;
  showTime?: number;
  mask?: boolean;
  zIndex?: number;
  onClose?: () => void;
}

/**
 * 组件状态定义
 */
const isShow = ref(false);
const title = ref("");
const showTime = ref(2000);
const mask = ref(false);
const zIndex = ref(999);
const timer = ref(null);
let onCloseCallback = () => {};

/**
 * 路由实例
 */
const router = useRouter();
/**
 * 显示提示信息
 * @param {Object|string} params - 消息配置或提示文本
 * @param {number} [duration=2000] - 显示时长
 */
const showInfo = (params: string | MessageConfig, duration = 2000) => {
  // 处理参数
  const config = typeof params === "object" ? params : { title: params };
  const { title: messageTitle = "", showTime: messageTime, mask: messageMask, zIndex: messageZIndex, onClose } = config || {};

  // 更新状态
  title.value = messageTitle || "";
  showTime.value = messageTime || duration || 2000;
  mask.value = messageMask || mask.value;
  zIndex.value = messageZIndex || zIndex.value;
  onCloseCallback = onClose || (() => {});

  // 显示提示
  isShow.value = true;

  // 清理已有定时器
  if (timer.value) {
    window.clearTimeout(timer.value);
  }

  // 设置自动关闭
  timer.value = window.setTimeout(() => {
    isShow.value = false;
    if (typeof onCloseCallback === "function") {
      onCloseCallback();
    }
  }, showTime.value);
};

/**
 * 手动隐藏提示
 */
const hide = () => {
  if (timer.value) {
    window.clearTimeout(timer.value);
  }
  isShow.value = false;
};
/**
 * 监听路由变化
 */
watch(
  () => router.currentRoute.value,
  () => {
    isShow.value = false;
    if (timer.value) {
      window.clearTimeout(timer.value);
    }
  },
  { immediate: true }
);
/**
 * 组件卸载时清理
 */
onUnmounted(() => {
  if (timer.value) {
    window.clearTimeout(timer.value);
  }
});
/**
 * 暴露方法和属性
 */
defineExpose({
  showInfo,
  hide,
});
</script>

<style lang="less" scoped>
@import "./Message.less";
</style>
